import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgDisable = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <circle cx={8} cy={8} r={7.5} stroke="#5D6B82" />
    <path
      d="m13.5 3-11 10"
      stroke="#5D6B82"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDisable);
export default ForwardRef;
